var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusIcBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "13.0pt",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 13 13",
    width: "13.0pt",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66663 5.66602L5.66663 0.666016L7.33329 0.666016L7.33329 5.66602L12.3333 5.66602L12.3333 7.33268L7.33329 7.33268L7.33329 12.3327L5.66663 12.3327L5.66663 7.33268L0.666626 7.33268L0.666626 5.66602L5.66663 5.66602Z",
    fill: "#5b5b5b",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcBlack);
export default __webpack_public_path__ + "static/media/plus_ic_black.94bec7f709e4a184de23a8463b887c4b.svg";
export { ForwardRef as ReactComponent };